import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";

import {
  saveLuckyDrawBannerRequest,
  saveLuckyDrawBannerSuccess,
  saveLuckyDrawBannerFailure,
  getLuckyDrawBannersRequest,
  getLuckyDrawBannersSuccess,
  getLuckyDrawBannersFailure,
  updateLuckyDrawBannerStatusRequest,
  updateLuckyDrawBannerStatusSuccess,
  updateLuckyDrawBannerStatusFailure,
  getJewellerBannerRequest,
  getJewellerBannerSuccess,
  getJewellerBannerFailure,
} from "./luckyDrawBannerSlice";

function* handleSaveLuckyDrawBanner(action) {
  try {
    const { formData, listParams } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/saveInstalaxmiBanner`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (response.data.success) {
      yield put(saveLuckyDrawBannerSuccess(response.data));
      toast.success(response.data.message || "Banner saved successfully");
      yield put(getLuckyDrawBannersRequest(listParams));
    } else {
      yield put(saveLuckyDrawBannerFailure(response.data.message));
      toast.error(response.data.message || "Failed to save banner");
    }
  } catch (error) {
    yield put(saveLuckyDrawBannerFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to save banner");
  }
}

function* fetchLuckyDrawBanners(action) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/getInstalaxmiBanners`,
      { params: action.payload || {} },
    );

    yield put(getLuckyDrawBannersSuccess(response.data));
  } catch (error) {
    yield put(getLuckyDrawBannersFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to fetch banners");
  }
}

function* updateLuckyDrawBannerStatusSaga(action) {
  try {
    const { id, status } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/updateInstalaxmiBannerStatus/${id}`,
      { status },
    );

    if (response.data.success) {
      yield put(updateLuckyDrawBannerStatusSuccess(response.data.data));
      toast.success(response.data.message || "Status updated");
    } else {
      yield put(updateLuckyDrawBannerStatusFailure(response.data.message));
      toast.error(response.data.message || "Failed to update status");
    }
  } catch (error) {
    yield put(updateLuckyDrawBannerStatusFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to update status");
  }
}

function* fetchJewellerBanner() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/getJewellerInstalaxmiBanner`,
    );

    yield put(getJewellerBannerSuccess(response.data));
  } catch (error) {
    yield put(getJewellerBannerFailure(error.message));
  }
}

export function* luckyDrawBannerSaga() {
  yield takeLatest(getJewellerBannerRequest.type, fetchJewellerBanner);
  yield takeLatest(saveLuckyDrawBannerRequest.type, handleSaveLuckyDrawBanner);
  yield takeLatest(getLuckyDrawBannersRequest.type, fetchLuckyDrawBanners);
  yield takeLatest(
    updateLuckyDrawBannerStatusRequest.type,
    updateLuckyDrawBannerStatusSaga,
  );
}
